module.exports = __webpack_public_path__ + "img/want_sale.5dd7cf14.svg";